<template>
    <div class="container">

        <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
        <h1 v-if="language.includes('es')">Relatos Culturales</h1>  
        <h1 v-else>Spanish Folktales</h1>

        <div v-if="language.includes('es')" class="texto">
            <p>¿Has visto o escuchado alguna vez sobre la película <strong>Encanto</strong>? Sabías que la trama se creó a partir de los relatos hechos por los antepasados que muchas veces cambiaron la forma de ver el mundo y a través del tiempo este relato fue una gran inspiración para artistas y cinematográficos que la convirtieron en película y a su vez crearon canciones. </p>
            <p>Este objeto virtual de aprendizaje (OVA) Se creó para que escuches y leas relatos de latinoamericanos que han pasado por varias generaciones y te ayudaran a comprender el estilo de vida y experiencias de vida de un gran porcentaje de latinoamericanos. </p>
            <p style="text-align: center;"><strong> Este objeto virtual de aprendizaje esta dirijido a:</strong></p>
        </div>
        <div v-else class="texto">
            <p>Have you ever seen or heard about the movie <strong>Encanto</strong>? Did you know that the plot was created from the stories made by Latin American ancestors that many times changed the way of seeing the world and through time? This story was a great inspiration for artists and filmmakers who turned it into a movie and in turn created songs too. </p>
            <p>This virtual learning object (VLO) was created for you to listen and read stories from Latin Americans who have passed through several generations and will help you understand the lifestyle and life experiences of a large percentage of them.</p>
            <p style="text-align: center;"><strong>The purpose of this VLO is described as follows:</strong></p>
        </div>

        <div>
            <button class="option_button" @click="mostrarOpcion(1)" :style="[botonActivo === 1 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton1.png?alt=media&token=18daa9ae-0f00-4548-9ca0-e035c8ca4072');"></button>
            <button class="option_button" @click="mostrarOpcion(2)" :style="[botonActivo === 2 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton2.png?alt=media&token=4dd20b6a-dcf3-4297-8609-c92ba3d60fc6');"></button>
            <button class="option_button" @click="mostrarOpcion(3)" :style="[botonActivo === 3 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton3.png?alt=media&token=46c1ab41-ffe9-4394-b13c-db6f4835f7ad');"></button>
            <button class="option_button" @click="mostrarOpcion(4)" :style="[botonActivo === 4 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton4.png?alt=media&token=9c89255d-5f79-4927-80a7-589ef2068709');"></button>
            <button class="option_button" @click="mostrarOpcion(5)" :style="[botonActivo === 5 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton5.png?alt=media&token=40d2a47c-74e6-4f93-af4b-ad1161e5a954');"></button>
            <button class="option_button" @click="mostrarOpcion(6)" :style="[botonActivo === 6 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton6.png?alt=media&token=8b1142ae-2233-4c1c-8157-5bf890456a31');"></button>
            <button class="option_button" @click="mostrarOpcion(7)" :style="[botonActivo === 7 ? { 'background-color': '#25274F' } : '']" style="background-image: url('https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Fboton7.png?alt=media&token=9d65e3ad-a4ee-4352-8d24-671e84be92c3');"></button>
        </div>
        <div v-if="language.includes('es')">
            <RouterLink to="/registrarse">
                <button class="link_button">Registrarse</button>
            </RouterLink>
            <RouterLink to="/ingresar">
                <button class="link_button">Acceder</button>
            </RouterLink>
        </div>
        <div v-else>
            <RouterLink to="/registrarse">
                <button class="link_button">Request Access</button>
            </RouterLink>
            <RouterLink to="/ingresar">
                <button class="link_button">Log In</button>
            </RouterLink>
        </div>

        <Popup v-if="TogglePopup" v-on:metodo="cerrarOpcion" :texto="contenido" />

    </div>
</template>

<script>
import Popup from '@/components/Popup.vue'

export default {
    name: 'home',
    components: {
        Popup
    },
    mounted() {
        if (this.language.includes('es')) {
            document.title = 'Relatos Culturales'
        } else {
            document.title = 'Spanish Folktales'
        }
    },
    data () {
        return {
            language: navigator.language,
            TogglePopup: false,
            contenido: '',
            botonActivo: false
        }
    },
    methods: {
        mostrarOpcion(numero) {
            switch (numero) {
                case 1:
                    this.botonActivo = 1
                    if (this.language.includes('es')) {
                        this.contenido = 'Niños y adultos que aprenden español como lengua extranjera.'
                    } else {
                        this.contenido = 'People aged 7 and over who are learning Spanish as a foreign language.'
                    }
                    break
                case 2:
                    this.botonActivo = 2
                    if (this.language.includes('es')) {
                        this.contenido = 'Investigadores y lingüistas que quieren identificar los diferentes acentos, entonación, expresiones idiomáticas y uso general de la lengua de los hablantes nativos.'
                    } else {
                        this.contenido = 'Researchers and linguists who want to identify the different accents, intonation, idioms, and general language usage of native speakers.'
                    }
                    break
                case 3:
                    this.botonActivo = 3
                    if (this.language.includes('es')) {
                        this.contenido = 'Antropólogos e historiadores que necesitan analizar ideologías y aspectos culturales de algunos de los hablantes latinoamericanos que se encuentran inmersos en sus relatos.'
                    } else {
                        this.contenido = 'Anthropologists and historians who desire to analyze the ideologies and cultural aspects of some of the Latin American speakers who are immersed in their stories.'
                    }
                    break
                case 4: 
                    this.botonActivo = 4
                    if (this.language.includes('es')) {
                        this.contenido = 'Hablantes de lengua castellana (español) que están aprendiendo a leer y a escribir el idioma.'
                    } else {
                        this.contenido = 'Spanish speakers who are learning how to read and write the language.'
                    }
                    break
                case 5:
                    this.botonActivo = 5
                    if (this.language.includes('es')) {
                        this.contenido = 'Administradores pedagógicos y maestros de escuelas, colegios, institutos, universidades que necesitan un material adicional para sus currículos educativos con el fin que sus estudiantes aprendan sobre la cultura latinoamericana y uso de la lengua.'
                    } else {
                        this.contenido = 'Pedagogical administrators and teachers of schools, colleges, institutes, and universities who want additional material for their educational curriculum in order to learn about Latin American culture and the use of the language.'
                    }
                    break
                case 6:
                    this.botonActivo = 6
                    if (this.language.includes('es')) {
                        this.contenido = 'Psicólogos, psicopedagogos y terapistas del lenguaje que estudian sobre los comportamientos del ser humano de acuerdo a su cultura, el uso y pronunciación de las palabras y el impacto de los relatos en el aprendizaje.'
                    } else {
                        this.contenido = 'Psychologists, educational psychologists, and language therapists who study human behavior according to their culture, the use and pronunciation of words, and the impact of folktales on learning.'
                    }
                    break
                case 7:
                    this.botonActivo = 7
                    if (this.language.includes('es')) {
                        this.contenido = 'Profesores y/o maestros que desean vincular en sus currículos la importancia que sus estudiantes aprendan diversos tipos de textos como son: ciencia ficción, cuentos fantásticos de animales, fantasía, ficción histórica y realista, mitos, leyendas, narrativa personal, textos informativos y de procedimientos.'
                    } else {
                        this.contenido = 'Professors and teachers who wish to link in their curricula the importance that their students learn different types of texts such as science fiction, tales of fantastic animals, fantasy, historical and realistic fiction, myths, legends, personal narrative, and informative and procedural texts.'
                    }
                    break
                default:
                    this.contenido = ''
                    break
            }
            this.TogglePopup = true
        },
        cerrarOpcion() {
            this.TogglePopup = false
            this.botonActivo = false
        }
    }
}
</script>

<style src="@/assets/css/home.css" scoped></style>
